import { useState } from 'react';
import { Play } from 'lucide-react';
import Modal from '@/components/ui/Modal';

interface StreamPlayerButtonProps {
  title: string;
  streamUrl?: string | null;
  modalTitle?: string;
  playLabel?: string;
  noPlayableStreamMessage?: string;
  rtspInlineNotSupportedMessage?: string;
  disabled?: boolean;
  className?: string;
}

const StreamPlayerButton = ({
  title,
  streamUrl,
  modalTitle,
  playLabel = 'Reproducir',
  noPlayableStreamMessage = 'No hay stream disponible para reproducir.',
  rtspInlineNotSupportedMessage = 'Los streams RTSP no se pueden reproducir en el navegador.',
  disabled = false,
  className = 'h-4 w-4 mr-1 cursor-pointer text-blue-600',
}: StreamPlayerButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const normalizedStreamUrl = (streamUrl || '').trim();
  const isRtspStream = /^rtsp:\/\//i.test(normalizedStreamUrl);
  const canInlinePlay = Boolean(normalizedStreamUrl) && !isRtspStream;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        className="inline-flex items-center justify-center disabled:cursor-not-allowed disabled:opacity-50"
        title={playLabel}
        aria-label={`${playLabel}: ${title}`}
      >
        <Play className={className} />
      </button>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={modalTitle || `${playLabel}: ${title}`}
        size="xl"
      >
        <div className="space-y-3">
          {canInlinePlay ? (
            <video
              key={normalizedStreamUrl}
              src={normalizedStreamUrl}
              controls
              playsInline
              className="w-full rounded-lg bg-black max-h-[70vh]"
            />
          ) : (
            <div className="rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-3 text-sm text-yellow-900">
              {isRtspStream ? rtspInlineNotSupportedMessage : noPlayableStreamMessage}
            </div>
          )}
          <div className="text-xs text-gray-600 break-all">
            {normalizedStreamUrl || noPlayableStreamMessage}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default StreamPlayerButton;
